var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 56,
    viewBox: "0 0 50 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.95898 18.512L25.0392 30.3464L24.6693 53.2758L3.95898 41.4413V18.512Z",
    fill: "#FFD550"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4082 4.82837L46.8582 17.0327L37.2427 22.2103L15.4229 10.3758L25.4082 4.82837Z",
    fill: "#FFD550"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2489 41.2108V18.0032C48.2471 17.668 48.157 17.3391 47.9875 17.0499C47.8181 16.7606 47.5754 16.5211 47.2839 16.3556L26.5712 4.7047C26.2921 4.54357 25.9755 4.45874 25.6533 4.45874C25.331 4.45874 25.0144 4.54357 24.7353 4.7047L4.02264 16.3556C3.73113 16.5211 3.48843 16.7606 3.319 17.0499C3.14958 17.3391 3.05942 17.668 3.05762 18.0032V41.2108C3.05942 41.546 3.14958 41.8748 3.319 42.1641C3.48843 42.4534 3.73113 42.6929 4.02264 42.8584L24.7353 54.5093C25.0144 54.6704 25.331 54.7552 25.6533 54.7552C25.9755 54.7552 26.2921 54.6704 26.5712 54.5093L47.2839 42.8584C47.5754 42.6929 47.8181 42.4534 47.9875 42.1641C48.157 41.8748 48.2471 41.546 48.2489 41.2108V41.2108Z",
    stroke: "#1C1F35",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1865 35.3734V23.1341L14.3555 10.5417",
    stroke: "#1C1F35",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9899 17.0381L25.865 29.6069L3.31641 17.0381",
    stroke: "#1C1F35",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8652 29.6069L25.6533 54.7446",
    stroke: "#1C1F35",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.999642 13.5696L11.6348 7.41699",
    stroke: "#1C1F35",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8468 1.50001L40.4873 7.64331",
    stroke: "#1C1F35",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4872 42.1809L29.8467 48.3242",
    stroke: "#1C1F35",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.97bd329fface194957f6aa5c1b9d77b9.svg";
export { ForwardRef as ReactComponent };